import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import FileUpload from '@/components/FileUpload';

import store from '../../../stores/allocation'

const propTypes = {
  value: PropTypes.sring,
  onChange: PropTypes.func,
};

export default function ImageField({ value, onChange }) {
  const [url, setUrl] = useState(value)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    onChange(url)
  }, [url])

  const handleUpload = async file => {
    setIsLoading(true)
    file = await store.image(file)
    setUrl(file.location)
    setIsLoading(false)
  }

  const handleRemove = () => {
    setUrl(null)
  }

  return <FileUpload
    onUpload={handleUpload}
    value={url}
    isLoading={isLoading}
    onRemove={handleRemove} />
}

ImageField.propTypes = propTypes
ImageField.defaultProps = {}
